import { treemapSquarify } from "d3";

/* The tiling method to be used for treemap rendering */
export const tilingMethod = treemapSquarify.ratio(1);
